import { lazy, type ComponentType } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any props: the wrapper is transparent to the component it loads
export function lazyWithRefresh<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory()
      .then((mod) => {
        // Clear retry counter on success so the next failure gets a full 2 retries.
        sessionStorage.removeItem("chunk-reload");
        return mod;
      })
      .catch((err) => {
        console.error("[lazyWithRefresh] chunk load failed:", err);
        const retries = Number(sessionStorage.getItem("chunk-reload") ?? "0");
        if (retries < 2) {
          sessionStorage.setItem("chunk-reload", String(retries + 1));
          window.location.reload();
          // Page is reloading — never-settling promise is fine here (page will unload).
          return new Promise<never>(() => {});
        }
        sessionStorage.removeItem("chunk-reload");
        // Reject so React's ErrorBoundary fires instead of hanging in Suspense forever.
        return Promise.reject(err);
      })
  );
}
